/*
 * @Description:
 * @Author: shenkaiyao
 * @Date: 2020-12-15 15:34:46
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2020-12-15 15:36:23
 */
import AreaCascader from './areaCascader';

export default AreaCascader